import { mainSiteUrl } from '@/mocks/categories';
import { splitCtaContent } from '@/mocks/seo-content';

export default function CTASplitSection() {
  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      {/* Left: Image */}
      <div className="lg:w-1/2 relative overflow-hidden bg-background-100">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20arrangement%20with%20sneakers%20hoodies%20and%20fashion%20accessories%20on%20warm%20terracotta%20surface%2C%20soft%20diffused%20overhead%20lighting%2C%20editorial%20fashion%20photography%2C%20clean%20artistic%20composition%2C%20neutral%20toned%20items%20with%20sage%20green%20accents%2C%20sophisticated%20lifestyle%20styling&width=1200&height=800&seq=cta-split-v3-2026&orientation=landscape"
          alt="Curated pandabuyspreadsheet product collection"
          title="Pandabuyspreadsheet curated product collection"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        {/* Overlay text on image */}
        <div className="absolute bottom-0 left-0 right-0 p-8 md:p-12">
          <p className="text-sm text-background-50/70 font-medium">Curated Collections</p>
          <p className="text-xl md:text-3xl font-heading font-bold text-background-50 leading-tight mt-1">
            Discover. Compare.
            <br />
            Shop Smarter.
          </p>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
      </div>

      {/* Right: CTA */}
      <div className="lg:w-1/2 flex items-center justify-center bg-background-50 py-14 md:py-20 px-4 md:px-12">
        <div className="max-w-md text-center">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight whitespace-pre-line">
            {splitCtaContent.headline}
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
            {splitCtaContent.description}
          </p>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="mt-8 inline-flex items-center justify-center gap-3 px-8 py-4 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            {splitCtaContent.buttonText}
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line text-sm"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}